<div class="modal-header" style="background: #1e1e1e; border-bottom: 1px solid rgba(255,255,255,0.1); padding: 16px 20px;">
  <h5 class="modal-title" style="color: #fff; font-size: 16px; font-weight: 600; margin: 0;">
    <i class="fas fa-clock me-2" style="color: #f59e0b;"></i>
    Are you still there?
  </h5>
</div>

<div class="modal-body" style="background: #1e1e1e; padding: 24px 20px; text-align: center;">
  <p style="color: #e0e0e0; font-size: 14px; margin-bottom: 8px;">
    You'll be automatically logged out due to inactivity in
  </p>
  <div style="color: #f59e0b; font-size: 40px; font-weight: 700; line-height: 1;">
    {{ secondsLeft }}
  </div>
  <p style="color: #9ca3af; font-size: 13px; margin-top: 8px;">
    seconds
  </p>
</div>

<div class="modal-footer" style="background: #1e1e1e; border-top: 1px solid rgba(255,255,255,0.1); padding: 12px 20px; display: flex; justify-content: flex-end; gap: 8px;">
  <button type="button" class="btn btn-outline-light" (click)="logoutNow()">Log Out Now</button>
  <button type="button" class="btn btn-warning" (click)="stillHere()">I'm Still Here</button>
</div>
